import React from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

const ShortLinkNav = ({ links }) => {
  return (
    <section className="border-b border-gray-300">
      <div className="w-full mx-auto px-grid block-w-container">
        <div className="overflow-y-scroll-indicator -mx-grid">
          <div>
            {links?.map((item, index) => (
              <Link
                key={index}
                link={item.link}
                className="relative block py-4 font-semibold bg-white whitespace-nowrap group text-accent2 px-grid hover:text-accent2-hover"
              >
                {item.link_text}
                <span className="absolute inset-x-0 justify-center hidden px-4 lg:flex bottom-4">
                  <span className="block w-0 h-px transition-all duration-300 group-hover:w-full bg-accent2-hover"></span>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ShortLinkNav
